import noImage from "../../assets/icons/no-image.jpeg";

export const ImageView = ({ label, value = "" }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      {value ? (
        <div className="w-[10rem] h-[10rem] my-1 rounded-lg">
          <img
            crossorigin="anonymous" 
            src={value}
            className="w-full h-full rounded-lg object-contain"
            alt={`${label}-image`}
          />
        </div>
      ) : (
        <div className="w-[10rem] h-[10rem] my-1 rounded-lg overflow-hidden">
          <img
            src={noImage}
            alt="No-image"
            className="rounded-lg w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};

export const DocumentView = ({ label, value = "" }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      {value ? (
        <div className="h-[14rem] w-full max-w-[350px] my-1 rounded-lg">
          <img
            crossorigin="anonymous" 
            src={value}
            className="w-full h-full rounded-lg object-contain"
            alt={`${label}-image`}
          />
        </div>
      ) : (
        <div className="h-[14rem] w-full max-w-[350px] my-1 rounded-lg overflow-hidden">
          <img
            src={noImage}
            alt="No-image"
            className="rounded-lg w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};

export const ImageViewArray = ({ label, value = [] }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      <div className="flex flex-wrap gap-5 items-center">
        {value?.map((item, index) => (
          <div key={index} className="w-[10rem] h-[10rem] my-1 rounded-lg">
            <img
              crossorigin="anonymous" 
              src={item}
              className="w-full h-full rounded-lg"
              alt={`${label}-image`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
